import { render, staticRenderFns } from "./SettingsUpload.vue?vue&type=template&id=4c066072"
import script from "./SettingsUpload.vue?vue&type=script&lang=js"
export * from "./SettingsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports